import React from 'react';


const MigrationHintBox = (props) => {

    let className = "migration-hint-box"


    return (
        <div className={className}>
            <div className={className + "__top"}>
                <p>Neue IP-Adresse und Datenbankverbindung</p>
            </div>
            <div className={className + "__body"}>
                <p>
                    Mit dem Wechsel des Tarifs erhältst du eine neue IP-Adresse und einen neuen Servernamen für deine Datenbanken. Wenn du dein CMS oder Shopsystem über unseren Softwaremanager installiert hast und die Domains bei Mittwald registriert sind, brauchst du dir darüber keine Gedanken zu
                    machen.
                </p>
                <p>
                    Du hast dein CMS oder Shopsystem manuell installiert oder nutzt eine Eigenentwicklung? Du hast Domains bei einem anderen Hoster registriert und leitest diese auf Mittwald weiter?
                </p>
                <p>
                    Bitte lies die folgenden Informationen um sicherzustellen, dass dein Projekt nach der Umstellung problemlos weiterläuft.
                </p>
            </div>
            <a target="_blank" rel="nofollow" href="https://www.mittwald.de/faq/neue-tarife/allgemeine-informationen/neue-datenbankverbindung-und-ip-adresse-anpassen">Zum FAQ-Artikel</a>
        </div>
    )

}

MigrationHintBox.propTypes = {}

export default MigrationHintBox


/** WEBPACK FOOTER **
 ** ./src/components/MigrationHintBox.js
 **/